(function() { window.GUID_ad74092a_c445_4754_9db4_4922fa79bf19 = { getGuid: function() { return "ad74092a-c445-4754-9db4-4922fa79bf19"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class SportEventFees {
            ShowModal(url) {
                Controls.PopupWizard.ShowAjaxModal(url, null, function ({ popup }) {
                    const popupWizard = popup;
                }, function ({ popup }) {
                    const popupWizard = popup;
                });
            }
        }
        Controls.SportEventFees = SportEventFees;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=sportevent-fees.js.map
